import styled from 'styled-components';

export const QuickPayContainer = styled.div`
width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const QuickPayTermsConditions = styled.div`
font-size: var(--font-size-text-sm);

& a:hover { 
    text-decoration-color: var(--grey-600);
    color: var(--grey-600);
}
`;
